import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getMonthYear } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Batch No.',
    accessor: 'batch_no'
  },
  {
    header: 'Exp Date',
    accessor: (row) => getMonthYear(row?.exp_date)
  },
  {
    header: 'Available Stock',
    accessor: (row)=> row?.productDetails?.totalQuantity
  }
];

export const AddProductDetailsForm = ({
  onClose,
  onAdd,
  editData,
  isEditMode,
  stock,
  setAddDetailsDialogOpen,
  stockProductDetails
}) => {
  const [input, setInput] = useState('');
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {},
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;



  useEffect(() => {
    if (isEditMode && editData) {
      console.log(editData,"HELLO EDIT ")
      const formattedExpDate = editData.exp_date ? new Date(editData.exp_date).toISOString().slice(0, 7) : '';
      const rate = parseFloat(editData.mrp) || 0;
      const billQty = parseFloat(editData.bill_qty) || 0;
      const calculatedAmount = rate * billQty;
      reset({
        product_name: editData.product?.main?.name || editData?.productDetails?.productInfo?.main?.name,
        rate: rate,
        bill_qty: billQty,
        amount: isNaN(calculatedAmount) ? 0 : calculatedAmount,
        batch_no: editData.batch_no || '',
        exp_date: formattedExpDate,
        gst: editData.gst || 0,
        hsn_code: editData.hsn_code || '',
        product: editData?.productDetails?.productInfo?._id  || editData.product?._id,
        _id : editData?._id,
      });
    } else {
      reset();
    }
  }, [isEditMode, editData, reset]);

  const formSubmitHandler = (formValues) => {
    const transformedValues = {
      ...formValues
    };
    onAdd(transformedValues);
    setAddDetailsDialogOpen(false);
  };

  const handleProductSelection = (row) => {
    const formattedExpDate = row.exp_date ? new Date(row.exp_date).toISOString().slice(0, 7) : '';
    setValue('product_name', row.product?.main?.name || row?.productDetails?.productInfo?.main?.name);
    setValue('rate',  row?.productDetails?.mrp);
    setValue('batch_no', row.batch_no);
    setValue('exp_date', formattedExpDate);
    setValue('hsn_code', row?.hsn_code);
    setValue('gst',  row?.productDetails?.gst);
  };

const rateWatch = watch('rate');
const billQty = watch('bill_qty');
const discAmt = watch('disc_amt');
const discPer = watch("disc_per");

useEffect(() => {
  const parsedRate = parseFloat(rateWatch) || 0;
  const parsedQty = parseFloat(billQty) || 0;
  const parsedDisc = parseFloat(discAmt) || 0;

  const baseAmount = parsedRate * parsedQty;
  const amount = baseAmount - parsedDisc;

  setValue('amount', amount >= 0 ? amount : 0);

  if (baseAmount > 0 && parsedDisc >= 0) {
    const calculatedDiscPer = (parsedDisc / baseAmount) * 100;
    setValue('disc_per', calculatedDiscPer.toFixed(2)); 
  } else {
    setValue('disc_per', '0');
  }
}, [rateWatch, billQty, discAmt, setValue]);




  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Product Batch Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              data={stockProductDetails || []}
              sx={{ fontSize: '32px' }}
              columns={TABLE_HEADER}
              onRowClick={handleProductSelection}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                <TextField sx={{ flex: 0.8 }} name="product_name" placeholder="Product Name" disabled/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                <TextField sx={{ flex: 0.8 }} name="rate" placeholder="Bill Qty" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bill Qty</Typography>
                <TextField sx={{ flex: 0.8 }} name="bill_qty" placeholder="Bill Qty" />
              </Stack>
                 <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Disc Per/Amt</Typography>
                <TextField sx={{ flex: 0.4 }} name="disc_per" placeholder="Disc Per" type="number"/>
                <TextField sx={{ flex: 0.4 }} name="disc_amt" placeholder="Disc Amt" type="number"/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
                <TextField sx={{ flex: 0.8 }} name="batch_no" placeholder="Batch No" disabled/>
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Exp Date/HSN Code</Typography>
                <TextField sx={{ flex: 0.4 }} name="exp_date" type="month" disabled/>
                <TextField sx={{ flex: 0.4 }} name="hsn_code" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>GST%</Typography>
                <TextField sx={{ flex: 0.8 }} name="gst" placeholder="GST %" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                <TextField sx={{ flex: 0.8 }} name="amount" placeholder="GST %" />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
